// extracted by mini-css-extract-plugin
export default {"container":"createNotifications_container__RCNq1","wrapper":"createNotifications_wrapper__DVT6K","main":"createNotifications_main__OiW5b"};